import { NgModule  }             from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                          from '../shared/shared.module';
import { TableModule }                           from '../table/table.module';
import { VehicleActionsComponent }               from './vehicle.actions.component';
import { VehicleHistoryActionsComponent }        from './vehicle.history.actions.component';
import { VehicleHistoryRowExpandComponent }      from './vehicle.history.row.expand.component';
import { VehicleInfoComponent }                  from './vehicle.info.component';
import { VehicleInvoiceItemsRowExpandComponent } from './vehicle.invoice-items.row.expand.component';
import { VehiclesComponent }                     from './vehicles.component';
import { VehiclesService }                       from './vehicles.service';
import { VehiclesStates }                        from './vehicles.states';

@NgModule({
  declarations: [
    VehicleActionsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehiclesComponent
  ],
  entryComponents: [
    VehicleActionsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehiclesComponent
  ],
  exports: [
    VehicleActionsComponent,
    VehicleHistoryActionsComponent,
    VehicleHistoryRowExpandComponent,
    VehicleInfoComponent,
    VehicleInvoiceItemsRowExpandComponent,
    VehiclesComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: VehiclesStates })
  ],
  providers: [
    VehiclesService
  ]
})
export class VehiclesModule {}
